export const annahmeverzugCheckboxZodDescription = "annahmeverzugCheckbox";
